<template>
  <div class="myInvitePage">
    <div class="sbarBox">
      <img src="https://pohto-imgs.oss-cn-beijing.aliyuncs.com/uploads/2025/1106/320025FB40AC5888.jpg" alt="" />
    </div>

    <div class="allCon">
      <!-- 统计卡片 -->
      <div class="statsCard">
        <div class="statsIcon">
          <van-icon name="friends" size="28" color="#02599F" />
        </div>
        <div class="statsInfo">
          <h2>我的邀请</h2>
          <p>已成功邀请 <span class="count">{{ invisList.length }}</span> 位好友</p>
        </div>
      </div>

      <!-- 邀请列表 -->
      <div class="inviteListBox">
        <div class="listHeader">
          <span class="col-name">姓名</span>
          <span class="col-company">单位</span>
          <span class="col-phone">手机</span>
        </div>

        <div class="listContent" v-if="invisList.length > 0">
          <div
            v-for="(item, index) in invisList"
            :key="item.visitorID"
            class="listItem"
          >
            <span class="col-index">{{ index + 1 }}</span>
            <span class="col-name">{{ maskName(item.visitorName) }}</span>
            <span class="col-company">{{ maskCompany(item.visitorComName) }}</span>
            <span class="col-phone">{{ maskPhone(item.visitorPhone) }}</span>
          </div>
        </div>

        <div class="emptyBox" v-else>
          <div class="emptyIcon">📬</div>
          <p>暂无邀请记录</p>
          <span class="emptyTip">快去邀请好友一起参加展会吧！</span>
        </div>
      </div>

      <div class="backBtn">
        <van-button class="back-button" plain round @click="goBack">
          <van-icon name="arrow-left" /> 返回
        </van-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import api from '@/api'

const store = useStore()
const router = useRouter()

const ExhCode = computed(() => store.state.ExhCode)
const VisitorID = computed(() => store.state.VisitorID)

const invisList = ref([])

// 获取邀请列表
const getInvitedList = async () => {
  const res = await api.GetVisitorListApi({
    exhcode: ExhCode.value,
    VisitorID: VisitorID.value
  })
  if (res.data) {
    invisList.value = res.data
  }
}

// 姓名脱敏：保留第一个字，其余用*替代
const maskName = (name) => {
  if (!name) return '***'
  if (name.length <= 1) return name
  return name.charAt(0) + '*'.repeat(name.length - 1)
}

// 单位脱敏：保留前2个字和后2个字，中间用***替代
const maskCompany = (company) => {
  if (!company) return '***'
  if (company.length <= 4) return company
  return company.substring(0, 2) + '***' + company.substring(company.length - 2)
}

// 手机脱敏：保留前3位和后4位，中间用****替代
const maskPhone = (phone) => {
  if (!phone) return '***'
  if (phone.length < 7) return phone.substring(0, 1) + '****' + phone.substring(phone.length - 1)
  return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4)
}

// 返回
const goBack = () => {
  router.push({ path: '/success' })
}

onMounted(() => {
  getInvitedList()
})
</script>

<style lang="less" scoped>
.myInvitePage {
  min-height: 100vh;
  background: #fff;

  .sbarBox {
    img {
      width: 100%;
    }
  }

  .allCon {
    border-radius: 8vw 8vw 0 0;
    margin-top: -7.5vw;
    background: #fff;
    position: relative;
    padding: 5vw 4vw;
  }

  .statsCard {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(2, 89, 159, 0.08) 0%, rgba(85, 169, 114, 0.08) 100%);
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(2, 89, 159, 0.1);

    .statsIcon {
      width: 50px;
      height: 50px;
      margin-right: 15px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      box-shadow: 0 2px 8px rgba(2, 89, 159, 0.15);
    }

    .statsInfo {
      h2 {
        font-size: 20px;
        color: #02599F;
        margin-bottom: 5px;
      }

      p {
        font-size: 14px;
        color: #666;

        .count {
          font-size: 24px;
          font-weight: bold;
          color: #02599F;
          margin: 0 3px;
        }
      }
    }
  }

  .inviteListBox {
    background: #fff;
    border-radius: 16px;
    padding: 0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    .listHeader {
      display: flex;
      padding: 15px 10px;
      background: linear-gradient(90deg, rgba(2, 89, 159, 0.1) 0%, rgba(85, 169, 114, 0.1) 100%);
      font-weight: bold;
      color: #02599F;
      font-size: 14px;
      border-bottom: 2px solid;
      border-image: linear-gradient(90deg, #02599F 0%, #55A972 100%) 1;

      .col-name {
        width: 30%;
        text-align: center;
        padding-left: 25px;
      }

      .col-company {
        width: 40%;
        text-align: center;
      }

      .col-phone {
        width: 30%;
        text-align: center;
      }
    }

    .listContent {
      .listItem {
        display: flex;
        align-items: center;
        padding: 15px 10px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        color: #666;
        transition: background 0.2s;

        &:last-child {
          border-bottom: none;
        }

        &:nth-child(odd) {
          background: rgba(2, 89, 159, 0.02);
        }

        &:hover {
          background: rgba(2, 89, 159, 0.05);
        }

        .col-index {
          width: 25px;
          height: 25px;
          background: linear-gradient(135deg, #02599F 0%, #55A972 100%);
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: bold;
          margin-right: 10px;
          flex-shrink: 0;
        }

        .col-name {
          width: 25%;
          text-align: center;
          color: #333;
          font-weight: 500;
        }

        .col-company {
          width: 40%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .col-phone {
          width: 30%;
          text-align: center;
          font-family: 'Courier New', monospace;
        }
      }
    }

    .emptyBox {
      padding: 60px 20px;
      text-align: center;

      .emptyIcon {
        font-size: 60px;
        margin-bottom: 15px;
      }

      p {
        color: #333;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 8px;
      }

      .emptyTip {
        color: #999;
        font-size: 13px;
      }
    }
  }

  .backBtn {
    margin-top: 25px;
    text-align: center;
    padding-bottom: 30px;

    .back-button {
      border-color: #02599F;
      color: #02599F;
      padding: 0 30px;

      &:active {
        background: linear-gradient(90deg, #02599F 0%, #55A972 80%, #A1C98B 100%);
        color: #fff;
        border-color: transparent;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .myInvitePage {
    .allCon {
      border-radius: 20px;
      padding: 20px 100px;
      margin-top: -3vw;
    }

    .statsCard {
      max-width: 500px;
      margin: 0 auto 20px;
    }

    .inviteListBox {
      max-width: 600px;
      margin: 0 auto;
    }
  }
}
</style>
